export const environment = {
  production: false,
  apiUrl: "https://api-hml.hgdigital.io/setera-api/v1",

  othersUrl: {
    api: "https://api-hml.hgdigital.io/",
    core: "https://api-hml.hgdigital.io/setera-core/v1",
    reports: "https://api-hml.hgdigital.io/setera-reports/v1",
    events: "https://api-hml.hgdigital.io/setera-events/v1",
  },

  apiKeyFipe: "d72b569603a805c199beb37a9928f35d",
  googleApiGeoLocateKey: "AIzaSyA1PnE4tYfqi3A9E26L40pw4l1QlsYBE0g",
  apibase: "https://api-hml.hgdigital.io/setera-api-base/v1",
  apiSuperset: "https://api-hml.hgdigital.io/setera-superset/v1",
  apiMapBox:
    "pk.eyJ1IjoicmVuYXRvcGdvbWVzIiwiYSI6ImNsMDJvMnEyMzEydGYzaW8wZWhxbzN5eGoifQ.4xlmxw4zg5HeGe2b0ovW5g",
  // Configuração das novas apis, seguindo o modelo dos novos projetos e com suporte a HATEOAS
  apisConfig: {
    seteraFleetApi: {
      microServiceBaseUrl: "https://api-hml.hgdigital.io/",
      apiBaseUrl: "https://api-hml.hgdigital.io/setera-fleet/v1/",
    },
    seteraTrackingHardwareApi: {
      microServiceBaseUrl: "https://api-hml.hgdigital.io/",
      apiBaseUrl: "https://api-hml.hgdigital.io/setera-tracking-hardware/v1/",
    },
    seteraReportEngine: {
      microServiceBaseUrl: "https://api-hml.hgdigital.io/",
      apiBaseUrl: "https://api-hml.hgdigital.io/setera-report-engine/v1/",
    },
    seteraAnalyzeTrip: {
      microServiceBaseUrl: "https://api-hml.hgdigital.io/",
      apiBaseUrl: "https://api-hml.hgdigital.io/setera-analyze-trip/v1/",
      wsUrl: "",
      wsPath: "/ws/analyze-report/operator",
    },
    gateway: {
      baseOauthUrl: "https://api-manager.hgdigital.io/oauth2",
      clientId: "8joUf_wrLXuGLEubEyvVZGfoKSsa",
      clientSecret: "u_kgidyDT8QeREETjyJHdCLc1goa",
    },
    seteraStreaming: {
      microServiceBaseUrl: "https://api-hml.hgdigital.io/",
      apiBaseUrl: "https://api-hml.hgdigital.io/setera-streaming/v1/",
      //wsUrl: "ws://localhost:8085/ws/stream",
      // Configurações do SRS Server
      srs: {
        host: "streaming-hml.setera.seg.br",
        port: 80,
        app: "setera",
        // URLs para diferentes protocolos
        hlsUrl: "https://streaming-hml.setera.seg.br/setera",
        flvUrl: "https://streaming-hml.setera.seg.br/setera",
        webrtcUrl: "https://streaming-hml.setera.seg.br/rtc/v1/play",
      },
    },
  },
  keycloakConfig: {
    url: "https://auth-hml.setera.seg.br",
    realm: "Setera",
    clientId: "setera-web",
  },
};
